import { Field } from 'Util/Query';

export class OrderTrackQuery {
    getQuery({ order_id, email }) {
        return new Field('OrderTrack')
            .addArgument('orderIncrementId', 'Int', order_id)
            .addArgument('customerEmailId', 'String!', email)
            .addFieldList(this._getOrderFields());
    }

    _getOrderFields() {
        return [
            'order_id',
            'customer_name',
            'customer_email',
            'shipping_address',
            'billing_address',
            'shipping_method',
            'shipping_description',
            'base_total',
            'discount',
            'tax',
            'grand_total',
            'customize_product',
            'simple_product',
            'payment_method',
            'order_status',
            'shipping_amount',
        ];
    }
}

export default new OrderTrackQuery();
